import { render, staticRenderFns } from "./CategoryField.vue?vue&type=template&id=f03268b6&scoped=true"
import script from "./CategoryField.vue?vue&type=script&lang=js"
export * from "./CategoryField.vue?vue&type=script&lang=js"
import style0 from "./CategoryField.vue?vue&type=style&index=0&id=f03268b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03268b6",
  null
  
)

export default component.exports